export const defaultSoftwareLinks = [
  {
    id: "software-wps-office",
    name: "WPS Office",
    url: "https://www.wps.cn/",
    logo: "/images/software/wps-office.png",
    isPublic: true,
  },
  {
    id: "software-creative-cloud",
    name: "Creative Cloud",
    url: "https://creativecloud.adobe.com/apps/download/creative-cloud",
    logo: "/images/software/creative-cloud.png",
    isPublic: true,
  },
  {
    id: "software-seven-zip",
    name: "7-Zip",
    url: "https://www.7-zip.org/",
    logo: "/images/software/seven-zip.png",
    isPublic: true,
  },
  {
    id: "software-chrome",
    name: "Chrome",
    url: "https://www.google.com/chrome/",
    logo: "/images/software/chrome.png",
    isPublic: true,
  },
  {
    id: "software-everything",
    name: "Everything",
    url: "https://www.voidtools.com/zh-cn/",
    logo: "/images/software/everything.png",
    isPublic: true,
  },
  {
    id: "software-potplayer",
    name: "PotPlayer",
    url: "https://potplayer.daum.net/",
    logo: "/images/software/potplayer.png",
    isPublic: true,
  },
  {
    id: "software-vlc",
    name: "VLC Player",
    url: "https://www.videolan.org/vlc/",
    logo: "/images/software/vlc.png",
    isPublic: true,
  },
  {
    id: "software-typora",
    name: "Typora",
    url: "https://typora.io/",
    logo: "/images/software/typora.png",
    isPublic: true,
  },
];
